var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitterBird(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "15px",
    viewBox: "0 0 20 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDED1-Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "components/Artist-Profile-Sidebar",
    transform: "translate(-8.000000, -98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(8.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconTwitterBird"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button-Contents"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/social/instagram"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.11,18 C13.468,18 17.498,12.2307692 17.498,7.24713584 C17.498,7.07528642 17.498,6.92798691 17.498,6.75613748 C18.278,6.21603928 18.954,5.55319149 19.5,4.79214403 C18.772,5.08674304 18.018,5.28314239 17.212,5.38134206 C18.044,4.91489362 18.668,4.17839607 18.98,3.29459902 C18.2,3.73649755 17.342,4.03109656 16.432,4.20294599 C15.704,3.46644845 14.664,3 13.52,3 C11.31,3 9.516,4.69394435 9.516,6.7806874 C9.516,7.07528642 9.542,7.36988543 9.62,7.63993453 C6.292,7.49263502 3.354,5.9705401 1.378,3.68739771 C1.04,4.25204583 0.832,4.8903437 0.832,5.57774141 C0.832,6.87888707 1.534,8.05728314 2.6,8.72013093 C1.95,8.69558101 1.326,8.52373159 0.78,8.25368249 C0.78,8.27823241 0.78,8.27823241 0.78,8.30278232 C0.78,10.1194763 2.158,11.6661211 3.978,12.00982 C3.64,12.1080196 3.302,12.1325696 2.938,12.1325696 C2.678,12.1325696 2.418,12.1080196 2.184,12.0589198 C2.704,13.5564648 4.186,14.6612111 5.928,14.685761 C4.55,15.6923077 2.834,16.3060556 0.962,16.3060556 C0.65,16.3060556 0.312,16.2815057 0,16.2569558 C1.742,17.3617021 3.848,18 6.11,18",
    id: "Path",
    fill: "#858199"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterBird);
export default __webpack_public_path__ + "static/media/iconTwitterBird.a1488878.svg";
export { ForwardRef as ReactComponent };